import { type ReactNode, createContext, useContext, useMemo } from 'react';

import { isClientHydrated } from '#/rendering/state/renderingState';

type SsrApiDataContextValue = Partial<Record<string, unknown>>;

const SsrApiDataContext = createContext<SsrApiDataContextValue>({});

export function SsrApiDataContextProvider(props: {
  children: ReactNode;
  value: SsrApiDataContextValue;
}) {
  const { children, value } = props;
  const contextValue = useMemo(
    () => (isClientHydrated() ? {} : value),
    [value],
  );

  return <SsrApiDataContext value={contextValue}>{children}</SsrApiDataContext>;
}

export function useSsrApiDataContext() {
  return useContext(SsrApiDataContext);
}
